import styled from "styled-components";
import { Button } from "@security-watchdog/sw-ui-kit";

export const ButtonBack = styled(Button)`
  margin-bottom: 8px;
`;
